import { createRouter, createWebHistory } from 'vue-router';

import routes from 'virtual:generated-pages';
import { setupLayouts } from 'virtual:generated-layouts';

import { auth, needAuth, checkProduction } from './hook';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...setupLayouts(routes)
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach(auth);
router.beforeEach(needAuth);
router.beforeEach(checkProduction);

export default router
